import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id C45A21A3-671C-4B1A-B405-D625ECA93C11
 * name ceiling-light
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light.svg
 * tags
 * - Home Automation 
 */
export const CeilingLightIcon = createSvgIcon(<><path d="M8,9H11V4H13V9H16L20,17H4L8,9M14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18H14Z" /></>, 'CeilingLightIcon');
export default CeilingLightIcon